<div class="scroll-progress-container">
  <div class="scroll-progress-bar" id="scroll-progress-bar"></div>
</div>
<div class="container" scrollProgress>
  <div class="page_container">
    <app-hub-header
      [dataIsLoading]="isLoading"
      [description]="descriptionHeader"
      [headerImg]="headerImg ?? ''"
      [partsOfUrl]="partsOfUrl"
      [title]="titleHeader"
      [verticalSlug]="$safeNavigationMigration(vertical?.slug)"
      [headCat]="headCategorySlug"
      [subCat]="subCategorySlug"
      [entityData]="[vertical]"
    />

    <!-- Deep Link Buttons -->
    @if (deepLinkButtons.length > 0 && !isLoading) {
      <div class="deep-link-section max_width_page_component">
        <app-deep-link-buttons [buttons]="deepLinkButtons" />
      </div>
    }

    @if (hub?.content && hub?.content['main']) {
      @if (!isLoading) {
        <div class="section outer_body_container">
          <section
            class="table_of_content"
            [ngClass]="{ accordionView: innerWidth < 990 }"
          >
            @if (innerWidth < 990) {
              <div
                (click)="expandTableOfContent()"
                class="expand_table_of_content"
              >
                <h2 class="mobile_h2">{{ 'PLACEHOLDERS.I' | translate }}</h2>
                @if (tableOfContentExpanded) {
                  <mat-icon>expand_less</mat-icon>
                } @else {
                  <mat-icon>expand_more</mat-icon>
                }
              </div>
            }
            <ul
              class="content"
              [ngClass]="{ isExpanded: tableOfContentExpanded }"
            >
              @if (innerWidth > 990) {
                <h2 style="font-size: 20px; padding-top: 0 !important">
                  {{ 'PLACEHOLDERS.I' | translate }}
                </h2>
              }
              @for (h2 of h2Texts; track $index) {
                <li class="item">
                  <a
                    class="item"
                    (click)="scrollTo($event, $safeNavigationMigration(h2?.id))"
                    href="#{{ h2?.id }}"
                  >
                    {{ h2.text }}
                  </a>
                </li>
              }
            </ul>
          </section>
          <div class="body_container max_width_page_component">
            @if (!isLoading) {
              <section
                [innerHTML]="getMainContent() | safe: 'html'"
                class="content_from_mongo tables_on_gray_background"
              ></section>
            } @else {
              <app-header-loader [isBodyText]="true" />
            }
          </div>
        </div>
      }
    }

    <div class="section">
      <!-- Guides -->
      @if ((guideList && guideList.length) || isLoading) {
        <div id="guides-section" class="card_container_full_width">
          <app-generic-card
            [borderRadius]="'20px'"
            [dataIsLoading]="isLoading"
            [description]="
              $safeNavigationMigration(headCategory?.description_guides)
            "
            [displayMode]="'grid4'"
            [entityData]="guideList"
            [headCategory]="headCategorySlug"
            [subCategory]="subCategorySlug"
            [subSubCategory]="subSubCategorySlug"
            [maxImgHeight]="300"
            [numberOfCards]="3"
            [title]="guideTitle"
          />
        </div>
      }

      <!-- PriceGuides -->
      @if ((priceGuideList && priceGuideList.length) || isLoading) {
        <div id="price-guides-section" class="card_container_full_width">
          <app-custom-card
            [dataIsLoading]="isLoading"
            [borderRadius]="'20px'"
            [description]="headCategory.description_price_guides"
            [displayMode]="'grid4'"
            [entityData]="priceGuideList"
            [headCategory]="headCategorySlug"
            [subCategory]="subCategorySlug"
            [maxImgHeight]="300"
            [numberOfCards]="3"
            [priceGuideId]="$safeNavigationMigration(vertical?.priceGuideId)"
            [verticalSlug]="$safeNavigationMigration(vertical?.slug)"
            [shouldDisplayPriceComp]="shouldDisplayPriceComp"
            [title]="priceGuideTitle"
            [isVerticalCard]="false"
          />
        </div>
      }

      @if (aIPriceGuides.length || isLoading) {
        <div class="card_container_full_width">
          <app-custom-card
            [dataIsLoading]="isLoading"
            [borderRadius]="'20px'"
            [description]="'PAGES.HUB.PRICE_DATA_DESC' | translate"
            [displayMode]="'grid4'"
            [entityData]="aIPriceGuides"
            [headCategory]="headCategorySlug"
            [subCategory]="subCategorySlug"
            [maxImgHeight]="300"
            [numberOfCards]="3"
            [priceGuideId]="mostRelevantAiPriceGuideId"
            [shouldDisplayPriceComp]="shouldDisplayPriceComp"
            [title]="priceDataTitle"
            [isVerticalCard]="false"
            [isAiPriceGuide]="true"
          />
        </div>
      }

      <!-- Tips&Tricks Guides -->
      @if ((tipsAndTrickList && tipsAndTrickList?.length) || isLoading) {
        <div id="tips-section" class="card_container_full_width">
          <app-generic-card
            [borderRadius]="'20px'"
            [dataIsLoading]="isLoading"
            [displayMode]="'grid3'"
            [description]="tipsDesc"
            [entityData]="tipsAndTrickList"
            [headCategory]="headCategorySlug"
            [subCategory]="subCategorySlug"
            [numberOfCards]="3"
            [title]="tipsTitle"
            [isTipsAndTricks]="true"
          />
        </div>
      }

      <!-- Vertical -->
      @if (vertical) {
        <div id="services-section" class="card_container_full_width">
          <app-custom-card
            [borderRadius]="'20px'"
            [dataIsLoading]="isLoading"
            [description]="vertical.mT"
            [displayMode]="'grid3'"
            [entityData]="[vertical]"
            [headCategory]="headCategorySlug"
            [subCategory]="subCategorySlug"
            [maxImgHeight]="400"
            [numberOfCards]="2"
            [shouldDisplayReviewComp]="true"
            [reviewCount]="reviewCount"
            [isVerticalCard]="true"
            [title]="verticalTitle"
          />
        </div>
      }

      <!-- SubHubs -->
      @if (subHubs.length > 0) {
        <div class="card_container_full_width">
          <app-generic-card
            [borderRadius]="'20px'"
            [dataIsLoading]="isLoading"
            [description]="'Udvalg af relateret emner indenfor kategorien'"
            [displayMode]="'grid3'"
            [entityData]="subHubs"
            [headCategory]="headCategorySlug"
            [subCategory]="subCategorySlug"
            [numberOfCards]="3"
            [title]="subHubTitle"
          />
        </div>
      }
    </div>

    <!-- Related Regions / Cities -->
    @if (vertical) {
      <app-links-container
        [vertical]="vertical!"
        [isJobsPage]="false"
        [useSubCategories]="true"
        [displayRelatedVertOnly]="false"
        [hideRelatedVerticals]="true"
        [url]="url"
        [isHubPage]="true"
      />
    }

    <!-- Local Service Index Pages -->
    @if (hasLocalServices) {
      <section class="local_service_index_pages">
        <a [href]="localServiceIndexLink" class="full-width-link">
          <article class="card" style="border-radius: 20px">
            <div class="card-bodytips_card_body">
              <h3>{{ 'PAGES.HUB.LOCAL_SERVICES_LINK' | translate }}</h3>
            </div>
          </article>
        </a>
      </section>
    }

    <!-- Mini Vertical Index Pages -->
    @if (hasMiniVerticals) {
      <section class="local_service_index_pages">
        <a [href]="miniVerticalIndexLink" class="full-width-link">
          <article class="card" style="border-radius: 20px">
            <div class="card-bodytips_card_body">
              <h3>{{ 'PAGES.HUB.MINI_SERVICES_LINK' | translate }}</h3>
            </div>
          </article>
        </a>
      </section>
    }

    <!-- Additional Links -->
    @if (additionalLinks.length > 0) {
      <section class="local_service_index_pages">
        @for (link of additionalLinks; track $index) {
          <a [href]="link.link" class="full-width-link">
            <article class="card" style="border-radius: 20px">
              <div class="card-bodytips_card_body">
                <h3>{{ link.text }}</h3>
              </div>
            </article>
          </a>
        }
      </section>
    }

    <!-- Consolidated affald hub: region → kommune → by → leaf pages.
         Only on the main /affald/hub — not the /affald/affald-have/hub sub-hub. -->
    @if (isAffaldPath) {
      <app-affald-hub-hierarchy />
    }

    <app-lp-footer />
  </div>
</div>

<div [innerHTML]="breadcrumbSchema | jsonLd"></div>
<div [innerHTML]="collectionPageSchema | jsonLd"></div>
<router-outlet></router-outlet>
